export default "__VITE_ASSET___TbtXfsE__"